import React from "react";

interface SubscriptionFilterLabelProps {
    filters: {
        isSubscription?: boolean;
    };
}

export const SubscriptionFilterLabel: React.FC<
    SubscriptionFilterLabelProps
> = ({ filters: { isSubscription } }) => {
    if (isSubscription === true) {
        return <>Subscription</>;
    }

    if (isSubscription === false) {
        return <>One-time</>;
    }

    return null;
};
